import { gql } from '@apollo/client';

export const TRANSFER = gql`
  fragment Transfer on Transfer {
    id
    credentialId
    credential {
      credentialType
      address
    }
    hash
    timestamp
    fromAddress
    toAddress
    contractAddress
    currency
    quantity
    groupId
    type
    direction
    transactionId
    accountId
    synthetic
  }
`;
